import pick from "lodash/pick";
import { selectedPolygonTypes } from "../Common/Constants";
import { havePermission } from "../../permissions";
import LAYERS_PERMISSIONS from "../../permissions/Layers.json";
const { smoking_zones } = selectedPolygonTypes;

const getPopulationGridRange = ({ data }) => {
	let min = Number.MAX_SAFE_INTEGER;
	let max = Number.MIN_SAFE_INTEGER;
	for (let obj of data) {
		if (obj.data.population < min) min = obj.data.population;
		if (obj.data.population > max) max = obj.data.population;
	}
	return { min, max };
};

const getSmokingZonePolygon = locations => {
	// locations = locations.filter(obj => obj?.data?.census_list.length > 0 && obj.data?.store_list.length > 0);
	return {
		polygons: locations.map((obj, ind) => {
			const {
				data: { store_list, census_list, SEC, population, smoking_area_id }
			} = obj;
			return {
				id: ind,
				_id: ind,

				coordinates: obj?.boundary?.polygon,
				style: {
					fillColor: "#FF000077",
					strokeColor: "#000000",
					zindex: 10
				},
				data: {
					store_list,
					census_list,
					SEC,
					population,
					smoking_area_id
				},
				filterData: {
					value: obj?.data?.population || 0
				},
				polygonClick: true,
				type: smoking_zones
			};
		})
	};
};

const getSmokingZoneSlider = ({ sliderHandler, type, locations }) => {
	if (!havePermission(LAYERS_PERMISSIONS.LAYER_SMOKING_ZONES_SLIDER)) return null;

	let { min, max } = getPopulationGridRange({ data: locations });
	return {
		min,
		max,
		sliderHandler,
		type
	};
};

const SmokingZonesService = {
	all: ({ locations, sliderHandler, type }) => {
		return {
			...pick(getSmokingZonePolygon(locations), ["polygons"]),
			...{ slider: getSmokingZoneSlider({ sliderHandler, locations, type }) }
		};
	},
	polygons: ({ locations }) => {
		return pick(getSmokingZonePolygon(locations), ["polygons"]);
	}
};

export default SmokingZonesService;
export { getSmokingZonePolygon, getSmokingZoneSlider };
